<template>
  <div id="questionThree"></div>
</template>

<script>
export default {
  name: "QuestionThree",
  props: {
    data: {
      type: Object,
      required: true,
      default: () => ({
        question:
          "What's the biggest challenge you face when creating content?",
        context: "Drop your answer in the comments 👇",
        chip: "Let's Discuss",
      }),
    },
    scale: {
      type: Number,
      required: true,
      default: 0.8,
    },
  },
  computed: {
    workspace() {
      return this.$store.state.workspace;
    },
  },
  mounted() {
    this.render();
  },
  watch: {
    scale: {
      handler() {
        this.render();
      },
      immediate: true,
      deep: true,
    },
    data: {
      handler() {
        this.render();
      },
      deep: true,
    },
  },
  methods: {
    render() {
      const el = document.getElementById("questionThree");
      if (!el) return;
      el.innerHTML = this.exportHTML();
    },
    exportHTML(exporting = false) {
      const containerSize = exporting ? 1200 : 1200 * this.scale;
      const questionSize = exporting ? 54 : 54 * this.scale;
      const contextSize = exporting ? 26 : 26 * this.scale;
      const logoHeight = exporting ? 45 : 45 * this.scale;
      const chipSize = exporting ? 18 : 18 * this.scale;
      const questionMarkSize = exporting ? 350 : 350 * this.scale;

      const logoSrc = this.workspace?.branding?.logo?.dark || "";
      const primaryColor =
        this.workspace?.branding?.color?.primary || "#e63946";

      let openingDiv = `<div style="height: ${containerSize}px; width: ${containerSize}px; aspect-ratio: 1 / 1;">`;

      let html = `
        ${openingDiv}
        <div
          style="
            background-color: #fafafa;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            height: 100%;
            width: 100%;
            aspect-ratio: 1 / 1;
            position: relative;
            overflow: hidden;
          "
        >
          <!-- Giant decorative question mark -->
          <div style="
            position: absolute;
            top: -20px;
            right: 40px;
            font-size: ${questionMarkSize}px;
            font-family: 'Playfair Display', 'Georgia', serif;
            font-weight: 900;
            color: #000000;
            opacity: 0.06;
            line-height: 1;
            pointer-events: none;
            user-select: none;
          ">?</div>

          <!-- Header with logo -->
          <div style="padding: 8%; position: relative; z-index: 1;">
            <img src="${logoSrc}" height="${logoHeight}px" alt="" />
          </div>

          <!-- Question content -->
          <div style="padding: 0 8% 8% 8%; position: relative; z-index: 1;">
            <div style="
              font-size: ${questionSize}px;
              font-family: 'Playfair Display', 'Georgia', serif;
              font-weight: 700;
              color: #1a1a1a;
              line-height: 1.3;
              margin-bottom: 24px;
              max-width: 85%;
            ">${this.data.question}</div>

            ${
              this.data.context
                ? `
            <p style="
              color: #666666;
              font-size: ${contextSize}px;
              margin: 0 0 32px 0;
              font-family: 'Inter', 'Helvetica Neue', sans-serif;
              display: inline-block;
              position: relative;
            ">
              ${this.data.context}
              <span style="
                position: absolute;
                bottom: -8px;
                left: 0;
                width: 60px;
                height: 4px;
                background: ${primaryColor};
              "></span>
            </p>
            `
                : ""
            }

            <!-- Chip -->
            <div style="display: flex; margin-top: 24px;">
              <span
                style="
                  display: inline-block;
                  background: #1a1a1a;
                  color: #ffffff;
                  font-size: ${chipSize}px;
                  font-weight: 600;
                  border-radius: 4px;
                  padding: 12px 20px;
                  letter-spacing: 0.08em;
                  text-transform: uppercase;
                  font-family: 'Inter', 'Helvetica Neue', sans-serif;
                "
              >
                ${this.data.chip}
              </span>
            </div>
          </div>
        </div>
      </div>
      `;

      return html;
    },
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Playfair+Display:wght@600;700;900&display=swap");
</style>
